import { RelationshipDirection } from 'src/containers/ProjectDiagram/constants/modelConcept';
import { ModelConceptRelationship } from 'src/containers/ProjectDiagram/types/data';
import { Model } from 'src/containers/ProjectDiagram/types/model';
import { isModelConceptRelationship } from 'src/containers/ProjectDiagram/utils/data';
import { getModelConceptClassKey } from 'src/containers/ProjectDiagram/utils/modelConceptClass/createModelConceptClass';
import { disconnectModelConceptRelationshipForClass } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/disconnectModelConceptRelationshipForClass';
import { removeModelConceptRelationshipInstance } from 'src/containers/ProjectDiagram/utils/modelConceptRelationship/removeModelConceptRelationship';

export const removeModelConceptRelationshipForClass =
  ({
    classIri,
    direction,
    iri,
  }: {
    classIri: string;
    direction: RelationshipDirection | null;
    iri: string;
  }) =>
  (model: Model) => {
    const classKey = getModelConceptClassKey(classIri);

    const outgoing: ModelConceptRelationship[] = [];
    const otherRanges = new Set<string>();
    const incoming: ModelConceptRelationship[] = [];
    const otherDomains = new Set<string>();
    model.linkDataArray.forEach((data) => {
      if (isModelConceptRelationship(data) && data.value === iri) {
        const isOutgoing = data.from === classKey;
        const isIncoming = data.to === classKey;

        if (isOutgoing) {
          outgoing.push(data);
        } else if (data.from && !isIncoming) {
          otherDomains.add(data.from);
        }

        if (isIncoming) {
          incoming.push(data);
        } else if (data.to && !isOutgoing) {
          otherRanges.add(data.to);
        }
      }
    });

    // disconnect the relationship if there are no other domains or ranges
    if (
      (!direction && !(otherDomains.size + otherRanges.size)) ||
      (direction === RelationshipDirection.OUTGOING
        ? !otherDomains.size
        : !otherRanges.size)
    ) {
      disconnectModelConceptRelationshipForClass({
        classIri,
        direction,
        iri,
      })(model);
      return;
    }

    if (!direction || direction === RelationshipDirection.OUTGOING) {
      outgoing.forEach((data) => {
        removeModelConceptRelationshipInstance(data)(model);
      });
    }

    if (!direction || direction === RelationshipDirection.INCOMING) {
      incoming.forEach((data) => {
        removeModelConceptRelationshipInstance(data)(model);
      });
    }
  };
